export const hoursOfWorkListValue = [
  { id: 'hoursOfWork_1', name: 'пн-пт, кожного дня' },
  { id: 'hoursOfWork_2', name: 'пн-сб, кожного дня' },
  { id: 'hoursOfWork_3', name: 'пн-пт, парні дні' },
  { id: 'hoursOfWork_4', name: 'пн-пт, непарні дні' },
  { id: 'hoursOfWork_5', name: 'гнучкий графік роботи' },
];
